<div class=" card mt-3">


    <div class="row">
        <div class="col-md-6">
            <h5 i18n>
                Shipping Address
            </h5>
        </div>
        <div class="col-md-6 text-right"><span *ngIf="this.selectedAddress.id == -1 && this.customer !=null"
                                               style="color: red;
    margin-top: 10px;
    font-size: 12px;" i18n>Click to select shipping address.</span></div>
    </div>


    <div class="row">
        <div class="col-md-6 text-left"></div>
        <div class="col-md-6 text-right">
            <div *ngIf="customer != null" style="    margin-bottom: 10px;">
                <a href="#"  *ngIf="customer.addresses.length >= 0" (click)="openAddressDialog($event,-1)" i18n>
                    {{'add_new_address'|translate}}</a>
            </div>
        </div>
    </div>

    <div class="addresses_list" *ngIf="customer != null">

        <div *ngFor="let address of customer.addresses" (click)="setAddressSelected(address)" class="address_line">
            <div class="cont" *ngIf="((showAll==true) || selectedAddress.id == address.id)">
                <div class="row ">
                    <div class="col-8">
                        <div class="name">{{address.firstname}} {{address.lastname}}</div>
                        <div style="color:#888;"><i class="fa fa-globe"> </i> {{address.city}}, {{address.country_id}}
                        </div>
                        <div style="color:#888;"><i class="fa fa-phone"> </i> {{address.telephone}}</div>


                    </div>
                    <div class="col-4 text-right actions">

                        <i *ngIf="selectedAddress.id == address.id" class="la la-check-circle" style="    color: green;
    font-size: 30px;
    margin-top: 20px;"></i>
                        <i *ngIf="selectedAddress.id != address.id" class="la la-circle" style="    color: #222;
    font-size: 30px;
    margin-top: 20px;"></i>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 ">
                        <div class="" *ngIf="showAll == false && selectedAddress.id == address.id"><a i18n href="#"
                                                                                                      (click)="showAllAddresses($event)">Click
                            to change shipping address</a></div>
                    </div>
                    <div class="col-md-6 text-right actions" style="font-size:12px;">
                        <div class=" "><a i18n href="" (click)="deleteSelectedAddresses($event)"><i
                                class="fa fa-trash"></i> Delete address</a></div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>
